import { render, staticRenderFns } from "./VerticalTargeting.vue?vue&type=template&id=829a66fa&"
import script from "./VerticalTargeting.vue?vue&type=script&lang=js&"
export * from "./VerticalTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports